<template>
    <div class="search-filter-flairs" v-if="loaded">

        <!--  Price Flairs Start  -->
        <flair-button v-if="price && price.length === 2"
                      :flair="price"
                      :flairText="getFlairPriceText(price)"
                      @click="onCrossClickPrice()"
        ></flair-button>
        <!--  Price Flairs End  -->


        <!--  Services Flairs Start  -->
        <flair-button v-for="service in services" :key="'service' + service"
                      :flair="service"
                      :flairText="getFlairServiceText(service)"
                      @click="onCrossClickServices(service)"
        ></flair-button>
        <!--  Services Flairs End  -->

        <!--  Extra Content Flairs Start  -->
        <template v-if="extraContent">
            <flair-button v-if="extraContent.videos"
                          :flairText="getFlairExtraContentText('videos', extraContent.videos)"
                          @click="onCrossClickExtraContent('videos')"
            ></flair-button>

            <flair-button v-if="extraContent.fskContent"
                          :flairText="getFlairExtraContentText('fskContent', extraContent.fskContent)"
                          @click="onCrossClickExtraContent('fskContent')"
            ></flair-button>

            <flair-button v-if="extraContent.privateGallery === true"
                          :key="`flair-privateGallery-${extraContent.privateGallery}`"
                          :flairText="getFlairExtraContentText('privateGallery', extraContent.privateGallery)"
                          @click="onCrossClickExtraContent('privateGallery')"
            ></flair-button>
        </template>
        <!--  Extra Content End  -->

        <!--  Category Flairs Start  -->
        <flair-button v-if="category.type != null"
                      :flair="category.type"
                      :flairText="getFlairCategoryText('type',category.type)"
                      @click="onCrossClickCategory(category.type,'type')"
        ></flair-button>

        <flair-button v-if="category.meetingLocation != null"
                      :flair="category.meetingLocation"
                      :flairText="getFlairCategoryText('meetingLocation',category.meetingLocation)"
                      @click="onCrossClickCategory(category.meetingLocation,'meetingLocation')"
        ></flair-button>

        <!--  Category Flairs End  -->


        <!--  Features Flairs Start  -->
        <flair-button v-if="features.cup_size && features.cup_size.from"
                      :flair="features.cup_size"
                      :flairText="getFlairFeaturesTextCupSize(features.cup_size)"
                      @click="onCrossClickFeatures('cup_size')"
        ></flair-button>

        <flair-button v-if="features.gender"
                      :flair="features.gender"
                      :flairText="translateFeature(features.gender,'gender')"
                      @click="onCrossClickFeatures('gender')"
        ></flair-button>

        <flair-button v-for="(slider,name) in features.sliders" :key="'features-sliders' + name"
                      :flair="slider"
                      :flairText="getFlairFeaturesTextSlider(name,slider)"
                      @click="onCrossClickFeatures('sliders',name)"
        ></flair-button>

        <template v-for="(list,name,index1) in features.lists">
            <flair-button v-for="(value,index2) in list" :key="'features-lists-' + index1 + '-'+ index2"
                          :flair="value"
                          :flairText="getFlairFeaturesTextList(name,value)"
                          @click="onCrossClickFeatures('lists',name,value)"
            ></flair-button>
        </template>
        <!--  Features Flairs End  -->

    </div>
</template>

<script>
import debounce from 'debounce';
import FlairButtonComponent from "@/components/partials/FlairButtonComponent";
import priceFlairMixin from '../mixins/flairs/price-flairs-mixin';
import servicesFlairMixin from '../mixins/flairs/services-flairs-mixin';
import categoryFlairMixin from '../mixins/flairs/category-flairs-mixin';
import featuresFlairMixin from '../mixins/flairs/features-flairs-mixin';
import translateMixin from "@/components/mixins/translateMixin";
import extraContentFlairsMixin from "@/components/mixins/flairs/extra-content-flairs-mixin";

const data = () => {
    return {
        store: $store,
        unSubscribe: null,
        loaded: false,
        fullServices: [],
        constants: constants,
        debounceTime: 400,
    };
};

function onCrossClickPrice() {
    this.store.commit('setPrice', []);
    this.refreshSearch();
}

function onCrossClickServices(serviceId) {
    let services = _.cloneDeep(this.services);
    _.remove(services, id => _.isEqual(id, serviceId));

    this.store.commit('setServices', services);
    this.refreshSearch();
}

function onCrossClickCategory(value, subFilter) {
    const category = _.cloneDeep(this.category);
    this.removeCategoryFlair(category, subFilter, value);

    this.store.commit('setCategory', category);
    this.refreshSearch();
}

function onCrossClickExtraContent(subFilter) {
    let extraContent = _.cloneDeep(this.extraContent);
    extraContent = this.removeExtraContentFlair(extraContent, subFilter);

    this.store.commit('setExtraContent', extraContent);
    this.refreshSearch();
}

function onCrossClickFeatures(filterName, subFilterName, value) {

    let features = _.cloneDeep(this.features);

    if (filterName === 'cup_size') {
        delete features.cup_size;
    }

    if (filterName === 'gender') {
        // set `features.gender = null` to apply ALL gender filter
        // (null represents ALL as it's not part of the URL)
        // otherwise the search would fallback to the Female gender filter again
        features.gender = null;
    }

    if (filterName === 'sliders') {
        features = this.removeFeaturesFlairSlider(features, subFilterName)
    }

    if (filterName === 'lists') {
        features = this.removeFeaturesFlairList(features, subFilterName, value)
    }

    this.store.commit('setFeatures', features);
    this.refreshSearch();
}

function refreshSearch() {
    this.store.commit('refreshSearch', true);
}

export default {
    data,
    created() {
        this.refreshSearch = debounce(this.refreshSearch, this.debounceTime);
    },
    mixins: [
        categoryFlairMixin,
        featuresFlairMixin,
        priceFlairMixin,
        servicesFlairMixin,
        extraContentFlairsMixin,
        translateMixin,
    ],
    computed: {
        ...mapState([
            'price',
            'features',
            'services',
            'category',
            'allServices',
            'extraContent',
        ]),
    },
    watch: {
        allServices: {
            immediate: true,
            handler(val) {
                if (val && val.length) {
                    this.fullServices = val;
                    this.loaded = true;
                }
            },
        }
    },
    components: {
        'flair-button': FlairButtonComponent,
    },
    methods: {
        onCrossClickPrice,
        onCrossClickServices,
        onCrossClickCategory,
        onCrossClickFeatures,
        onCrossClickExtraContent,
        refreshSearch,
    }
}
</script>
